import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Paper,
  AppBar,
  Toolbar,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import { BarChart } from "@mui/x-charts/BarChart";

function Dialog_total({ abrirDialog, onClose, datosGrafico }) {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };
  // PARA SACAR LA LEYENDA
  const customize = {
    legend: { hidden: true },
  };

  const chartSetting = {
    yAxis: [
      {
        label: "Cantidad de stock total",
      },
    ],
    width: 650,
    height: 300,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: "translate(-20px, 0)",
      },
    },
  };

  return (
    <div>
      <Dialog fullScreen open={abrirDialog} onClose={handleClose}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Total de stock despachados
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              Cerrar
            </Button>
          </Toolbar>
        </AppBar>
        <DialogContent>
          {/* LEYENDA */}
          <Box
            sx={{
              backgroundColor: "#DEDEDE",
              border: "1px solid black",
              borderRadius: 2,
              padding: 2,
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)", // 2 columnas en pantallas xs y sm
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)", // 3 columnas en md
                lg: `repeat(${Math.min(
                  datosGrafico.sucursales.length,
                  6
                )}, 1fr)`, // hasta 6 en lg
                xl: `repeat(${Math.min(
                  datosGrafico.sucursales.length,
                  8
                )}, 1fr)`, // hasta 8 en xl
              },
              columnGap: 2,
              rowGap: 1,
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                gridColumn: {
                  xs: "span 2",
                  sm: "span 2",
                  md: "span 3",
                  lg: `span ${Math.min(datosGrafico.sucursales.length, 6)}`,
                  xl: `span ${Math.min(datosGrafico.sucursales.length, 8)}`,
                },
                color: "black",
              }}
            >
              Leyenda del gráfico
            </Typography>

            {datosGrafico.sucursales.map((sucursal, index) => (
              <Box
                key={sucursal}
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    backgroundColor: datosGrafico.colores[index],
                    marginRight: 1,
                    flexShrink: 0,
                    border: "1px solid #000",
                  }}
                />
                <Typography variant="body2">
                  {sucursal} -{" "}
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    Cant: {datosGrafico.dataset[index].cantidad || 0}
                  </Box>
                </Typography>
              </Box>
            ))}
          </Box>
          {/* GRAFICO */}
          <Paper elevation={10} sx={{ mt: 3 }}>
            <Typography
              align="center"
              style={{
                fontWeight: "bold",
                fontSize: 20,
                textAlign: "center",
                mt: 1,
              }}
            >
              Total de despachos por sucursal/planta
            </Typography>

            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                height: 300,
                width: "100%",
              }}
            >
              <BarChart
                xAxis={[
                  {
                    scaleType: "band",
                    data: ["Sucursales/Plantas"], // solo una categoría para alinear todas las barras
                  },
                ]}
                series={datosGrafico.dataset.map((item, index) => ({
                  data: [item.cantidad],
                  label: item.sucursal,
                  color: datosGrafico.colores[index],
                }))}
                {...chartSetting}
                {...customize}
              />
            </Box>
          </Paper>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default Dialog_total;
